import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../../../../lib/api-client';
import { ActionRequiredOrdersResult } from '../types/ActionRequiredOrdersResult';

export const useGetActionRequiredOrders = (actionRequiredID?: number,
    pendingOnly?: boolean, pastDueOnly?: boolean, activeOnly?: boolean) => {
    const { data, isLoading } = useQuery({
        queryKey: ['distributor-action-required-orders', actionRequiredID, pendingOnly, pastDueOnly, activeOnly],
        queryFn: async () => await apiClient.get('action-required/distributor-orders',
            {
                params: {
                    actionRequiredID: actionRequiredID,
                    pendingOnly: pendingOnly,
                    pastDueOnly: pastDueOnly,
                    activeOnly: activeOnly
                }
            }) as ActionRequiredOrdersResult
    });

    return {
        data,
        isLoading
    };
};
